import axios from "axios"

const intance = axios.create({
    // baseURL: window.location.href.indexOf('222.128.117.72')!==-1?'http://222.128.117.72:5567':'http://222.128.117.72:5567'
    // baseURL: '/api'
    //baseURL: 'http://150.223.12.84:5566'
});

// 添加请求拦截器
intance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    let singtrue = sessionStorage.getItem("token")
    config.headers.Authorization = singtrue//"SHA256-RSA2048 api_key='RT1uDdBtoW2MChPqG5HcerlxzFaNJZEs',timestamp='1646813646',signature='ABsn+zaVQxwHaT4Kybg+4c0tsfRzCvhHC4hYXtB4/9AF5SpaiHad6lSd3XUaUzFoTkN63zIfqFseqEOTf7dEkhwvCbln+j4a0RK4Cl9HmRpdRXqdfRD79mk6duG0yWIuQhVhwA1HvxhoV/sWLTAsXlvTfd6PW8v5fHx2FpXEnRg='"
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
intance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});
export default intance
